// @flow

import React from 'react';
import { token } from '@atlaskit/tokens';
import SearchIcon from '@atlaskit/icon/core/search';
import styled from 'styled-components';
import { Dimensions } from 'components/visuals';
import config from 'appconfig';

const Wrapper = styled.span`
  position: absolute;
  right: 0;
  top: ${Dimensions.units(2)}px;
`;

export default () => (
  <Wrapper>
    <a href={`${config.wacUrl}/search`}>
      <SearchIcon color={token('color.icon.subtle', '#626F86')} />
    </a>
  </Wrapper>
);
